import React from 'react';
import './Activity.css'

const Activity = ({ activity, handleAddToList }) => {
    // console.log( product, handleAddToList );
    const { name, img, age, details, time } = activity;


    return (
        <div className='activity'>
            <img src={img} alt=""></img>
            <div className='activity-info'>
                <p className='activity-name'>{name}</p>
                <p>{details}</p>
                <p><small>For Age: {age}</small></p>
                <p><small>Time required: {time}s</small></p>
            </div>
            <button onClick={() => handleAddToList(activity)} className='btn-list'>
                <p className='btn-text'>Add to List</p>

            </button>

        </div>
    );
};

export default Activity;